import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import Select from "react-select";
import reactSelectStyles from "features/shared/components/reactSelect/reactselectcustom.module.scss";
import { UserEnumDTO } from "features/shared/enums/dynamic/UserEnumDTO";
import { BindReactSelectFunction, FormErrors } from "features/shared/forms/hooks/useForm";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";

type Props = {
  name: string;
  suppliers: UserEnumDTO[];
  bindReactSelectField: BindReactSelectFunction;
  label?: string;
  errors?: FormErrors;
  visible?: boolean;
  className?: string;
};

const SupplierSelect = ({
  suppliers,
  name,
  bindReactSelectField,
  label,
  errors,
  visible,
  className = "col-md-6 pl-0 pr-0 pr-md-2"
}: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "supplierSelect");

  // render
  return (
    <FormGroup
      labelText={label ?? tLabels("label")}
      validationError={errors ? errors[name] : undefined}
      className={className}
      visible={visible}
    >
      <Select
        {...bindReactSelectField<UserEnumDTO>(
          name,
          "code",
          suppliers
        )}
        getOptionLabel={(supplier) => supplier.name!}
        captureMenuScroll={false}
        className={reactSelectStyles.customSelect}
        classNamePrefix="customSelect"
        placeholder={tLabels("placeholder")}
        noOptionsMessage={() => tLabels("noOptionsMessage")}
      />
    </FormGroup>
  );
};

export default SupplierSelect;
